module.exports = __webpack_public_path__ + "assets/squad-white.12e1a269.svg";